export const formComponent = {
  button_text: "Submit",
  errors: {
    field_required: "This field is required!",
    incorrect_mail: "This email address is incorrect.",
  },
  form: {
    consent: {
      beginning: "I agree to ",
      link1_text: "Terms and Conditions",
      link1_url: "/terms-and-conditions",
      separator: " and ",
      link2_text: "Privacy Policy",
      link2_url: "/privacy-policy",
    },
    button_text: "Submit",
  },
};
